<template>
  <!-- registrationStatus = 3: course finished, no need open course by link -->
  <tr
      class="profile-table__row"
      :class="{ 'profile-table__row_hover': registration['url-ts'] && registrationStatus !== 3 }"
      @click.prevent.stop="openTSUrl"
  >
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">{{ registration.id }}</div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">
        {{ registrationName }}
      </div>
    </td>

    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">{{ registrationLang }}</div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">
        {{ registrationTraining }}
      </div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item d-flex align-items-center">
        <span v-if="formatDate(registration.registrationCreatedAt)" class="mr-1 icon icon-calendar"/>
        <span class="">
           {{ formatDate( registration.registrationCreatedAt, 'DD.MM.YYYY' ) }}
        </span>
      </div>
    </td>
    <!--<td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item d-flex align-items-center">
        <span v-if="formatDate(registration.sessionStartAt)" class="mr-1 icon icon-calendar" />
        <span class="">
           {{ formatDate(registration.sessionStartAt, "DD.MM.YYYY") }}
        </span>
      </div>
    </td>-->
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">
        <div class="d-flex">
          <span
              class="badge badge-icon badge-pill mr-1"
              :class="
              courseTypeSlug == 'e-learning'
                ? 'badge-school'
                : courseTypeSlug == 'virtual-class'
                ? 'badge-combined'
                : courseTypeSlug == 'classroom'
                ? 'badge-class'
                : 'badge-combined'
            "
          />
          <span
              class="badge badge-icon badge-pill"
              :class="
              registrationStatus == 0
                ? 'badge-not-started'
                : registrationStatus == 1
                ? 'badge-icon_in-progress'
                : registrationStatus == 2
                ? 'badge-icon_fail'
                : registrationStatus == 3
                ? 'badge-icon_success'
                : 'badge-not-started'
            "
          ></span>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'RegistrationRow',
  props: [ 'registration', 'index', 'isLast' ],
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapFields( [ 'user' ] ),
    ...mapFields( [ 'registrations.registrations' ] ),
    registrationName() {
      let firstname = this.$lodash.get(
          this.registration,
          'traineeFirstname',
          ''
      );
      let lastname = this.$lodash.get( this.registration, 'traineeLastname', '' );
      return lastname + ' ' + firstname
    },
    registrationLang() {
      let tl = this.$lodash.get( this.registration, 'traineePreferredLanguage', '--' );
      if ( tl != null ) {
        return tl;
      } else return '--';
    },
    registrationStatus() {
      let rs = this.$lodash.get( this.registration, 'resultLessonStatus', false );
      console.log( 'registrationStatus', rs );
      if ( rs != null ) {
        return rs;
      } else return '--';
    },
    registrationTraining() {
      let cn = this.$lodash.get( this.registration, 'courseName', '--' );
      if ( cn != null ) {
        return cn;
      } else return '--';
    },
    courseTypeSlug() {
      return this.$lodash.get( this.registration, 'courseTypeSlug', '' );

    }
  },
  methods: {
    formatDate( date, format = 'YYYY.MM.DD' ) {
      if ( date && this.$moment( date ).isValid() ) {
        return this.$moment( date ).format( format );
      } else return '--';
    },
    openTSUrl() {
      const url = this.$lodash.get( this.registration, 'url-ts', false );
      if ( url && this.registrationStatus !== 3 )
        window.open( url, '_blank' );
    }
  }
};
</script>

<style scoped>
.profile-table__row_hover:hover .profile-table__item {
  background-color: #e1f1ff;
}

.profile-table__row_hover {
  cursor: pointer;
}

.profile-table__row_hover .profile-table__cell {
  cursor: pointer;
}
</style>
